
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { 
  Phone, 
  UsersRound, 
  TrendingUp, 
  FileCode, 
  Database, 
  BarChart2, 
  Cloud, 
  Flag, 
  Award 
} from 'lucide-react';

// Timeline data
const timelineData = [
  {
    year: "2012",
    title: "Oprichting Afsprakenmaker",
    description: "Eerste stappen als B2B callcenter met focus op telefonische prospectie voor Vlaamse bedrijven.",
    icon: <Phone className="h-8 w-8 text-brand-blue" />
  },
  {
    year: "2013",
    title: "Eerste KMO-clusters",
    description: "Start met focus op Vlaamse KMO's – specialisatie in leadgeneratie per regio.",
    icon: <UsersRound className="h-8 w-8 text-brand-blue" />
  },
  {
    year: "2015",
    title: "10.000e afspraak gepland",
    description: "Bewijs van schaalbaarheid en duurzame werking.",
    icon: <TrendingUp className="h-8 w-8 text-brand-blue" />
  },
  {
    year: "2018",
    title: "Integratie met Microsoft & inhouse development",
    description: "Unieke structuur op maat van klanten, waardoor processen geautomatiseerd raken.",
    icon: <FileCode className="h-8 w-8 text-brand-blue" />
  },
  {
    year: "2020",
    title: "COVID: focus op digitalisering",
    description: "Herstructurering + lancering eerste digitale tools onder druk van remote verkoop.",
    icon: <Cloud className="h-8 w-8 text-brand-blue" />
  },
  {
    year: "2021",
    title: "Trends Gazellen nominatie",
    description: "Eerste externe erkenning voor groei, innovatie en impact in de Vlaamse markt.",
    icon: <Award className="h-8 w-8 text-brand-blue" />
  },
  {
    year: "2022",
    title: "Start R&D rond Datavalue Exchange™ en Contract Engine™",
    description: "Eerste experimenten met data-intelligentie en contractautomatisatie.",
    icon: <Database className="h-8 w-8 text-brand-blue" />
  },
  {
    year: "2024",
    title: "Afsprakenmaker 2.0",
    description: "Lancering van webshop, veilingsysteem, app & automatisatieplatform.",
    icon: <BarChart2 className="h-8 w-8 text-brand-blue" />
  },
  {
    year: "2025",
    title: "Marktleider in hybride telemarketing",
    description: "Herpositionering als sales enablement platform voor Vlaamse KMO's.",
    icon: <Flag className="h-8 w-8 text-brand-blue" />
  },
];

const TimelineSection = () => {
  return (
    <section className="section bg-brand-lightBlue py-16">
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="section-title">Ons traject doorheen de jaren</h2>
          <p className="section-subtitle mx-auto max-w-3xl">
            Van een klein callcenter tot een gevestigde waarde in sales enablement voor Vlaamse KMO's. 
            Ontdek hoe we zijn gegroeid en geëvolueerd.
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {timelineData.map((milestone, index) => (
            <div 
              key={index}
              className="bg-white p-6 rounded-lg shadow-sm border border-gray-100 hover:shadow-md transition-all duration-300 animate-fade-in"
              style={{ animationDelay: `${index * 150}ms` }}
            >
              <div className="flex items-start mb-4">
                <div className="bg-white border-2 border-brand-blue rounded-full p-3 mr-4">
                  {milestone.icon}
                </div>
                <div>
                  <Badge variant="outline" className="bg-brand-lightBlue border-brand-blue text-brand-blue px-3 py-1 mb-2">
                    {milestone.year}
                  </Badge>
                  <h3 className="text-xl font-semibold text-gray-900">{milestone.title}</h3>
                </div>
              </div>
              <p className="text-gray-600">{milestone.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TimelineSection;
